"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WS_CONNECTION_NODE_ID = exports.TRANSACTION_ALREADY_SUBMITTED = exports.REQUEST_SUCCESS = exports.REQUEST_ACCEPTED = exports.PUBLISH_FAILURE = exports.NODEID_COOKIE_KEY = exports.MSG_SHARD = exports.MSG_NUM = exports.MISSING_REQUEST_DATA = exports.MISSING_INTERACTION_ID = exports.META_HANDSHAKE = exports.MESSAGE_REDELIVERY_OPTIONS = exports.GLIDE_REMEMBER_ME = exports.GLIDE_AMB_HUP_SIGNAL_RECONNECT_IN_SEC = exports.GLIDE_AMB_HANDSHAKE_LIMIT_ENABLED = exports.CHANNEL_READY_TO_DELIVER = exports.CHANNEL_NOT_READY_TO_DELIVER = exports.CANCEL_TRANSACTION_CHANNEL = exports.CANCEL_TRANSACTION_ACTION = void 0;
// Redelivery
var MSG_NUM = 'msg_num';
exports.MSG_NUM = MSG_NUM;
var MSG_SHARD = 'msg_shard';
exports.MSG_SHARD = MSG_SHARD;
var MESSAGE_REDELIVERY_OPTIONS = 'msg_redelivery_options';
exports.MESSAGE_REDELIVERY_OPTIONS = MESSAGE_REDELIVERY_OPTIONS;
var CHANNEL_READY_TO_DELIVER = 'Channel set to deliver messages now: ';
exports.CHANNEL_READY_TO_DELIVER = CHANNEL_READY_TO_DELIVER;
var CHANNEL_NOT_READY_TO_DELIVER = 'Channel set to not deliver messages until re-subscription & re-delivery of missed messages is over: ';
exports.CHANNEL_NOT_READY_TO_DELIVER = CHANNEL_NOT_READY_TO_DELIVER;
var META_HANDSHAKE = '/meta/handshake';
exports.META_HANDSHAKE = META_HANDSHAKE;
var WS_CONNECTION_NODE_ID = 'glide.amb.wsConnectionNodeId';
exports.WS_CONNECTION_NODE_ID = WS_CONNECTION_NODE_ID;
var NODEID_COOKIE_KEY = "glide_node_id_for_js";
exports.NODEID_COOKIE_KEY = NODEID_COOKIE_KEY;
var GLIDE_REMEMBER_ME = "glide.remember.me";
exports.GLIDE_REMEMBER_ME = GLIDE_REMEMBER_ME;
var GLIDE_AMB_HUP_SIGNAL_RECONNECT_IN_SEC = "glide.amb.hup.signal.reconnect.in.sec";
exports.GLIDE_AMB_HUP_SIGNAL_RECONNECT_IN_SEC = GLIDE_AMB_HUP_SIGNAL_RECONNECT_IN_SEC;
var GLIDE_AMB_HANDSHAKE_LIMIT_ENABLED = "glide.amb.client.websocket_handshake_limit_enabled"; // amb cancel API

exports.GLIDE_AMB_HANDSHAKE_LIMIT_ENABLED = GLIDE_AMB_HANDSHAKE_LIMIT_ENABLED;
var CANCEL_TRANSACTION_CHANNEL = "/service/transaction/cancel";
exports.CANCEL_TRANSACTION_CHANNEL = CANCEL_TRANSACTION_CHANNEL;
var CANCEL_TRANSACTION_ACTION = "cancelTransaction";
exports.CANCEL_TRANSACTION_ACTION = CANCEL_TRANSACTION_ACTION;
var REQUEST_SUCCESS = "200::Success";
exports.REQUEST_SUCCESS = REQUEST_SUCCESS;
var REQUEST_ACCEPTED = "202::Request accepted";
exports.REQUEST_ACCEPTED = REQUEST_ACCEPTED;
var MISSING_REQUEST_DATA = "400::Missing request data";
exports.MISSING_REQUEST_DATA = MISSING_REQUEST_DATA;
var MISSING_INTERACTION_ID = "400::Missing nowUiInteractionId id";
exports.MISSING_INTERACTION_ID = MISSING_INTERACTION_ID;
var TRANSACTION_ALREADY_SUBMITTED = "409::Transaction with nowUiInteraction has already been submitted for cancel";
exports.TRANSACTION_ALREADY_SUBMITTED = TRANSACTION_ALREADY_SUBMITTED;
var PUBLISH_FAILURE = "503::Unable to publish message";
exports.PUBLISH_FAILURE = PUBLISH_FAILURE;